function historyClearForward () {
  if (typeof window === 'undefined') return

  setTimeout(() => {
    window.history.pushState(null, null, null)
  }, 10)
}

module.exports = { historyClearForward }
